// Wait for both DOM content and full page load to ensure everything is ready
document.addEventListener('DOMContentLoaded', initEasterEgg);
window.addEventListener('load', initEasterEgg);

function initEasterEgg() {
  console.log('Easter egg script initialized');
  
  // Target the specific heading(s) in your section
  const headings = document.querySelectorAll('.section-template--18619066646693__rich_text_3EQ4Y8-padding h1, .section-template--18619066646693__rich_text_3EQ4Y8-padding .h1, .section-template--18619066646693__rich_text_3EQ4Y8-padding h2.h1');
  console.log('Found headings:', headings.length);
  
  if (headings.length > 0) {
    attachClickHandlers(headings);
  } else {
    // Try again after a delay in case elements load later
    setTimeout(function() {
      const delayedHeadings = document.querySelectorAll('.section-template--18619066646693__rich_text_3EQ4Y8-padding h1, .section-template--18619066646693__rich_text_3EQ4Y8-padding .h1, .section-template--18619066646693__rich_text_3EQ4Y8-padding h2.h1');
      console.log('After delay, found headings:', delayedHeadings.length);
      
      if (delayedHeadings.length > 0) {
        attachClickHandlers(delayedHeadings);
      } else {
        console.log('Setting up mutation observer for headings');
        setupMutationObserver();
      }
    }, 1000);
  }
  
  function attachClickHandlers(elements) {
    elements.forEach(heading => {
      // Avoid adding multiple handlers to the same element
      if (heading.hasAttribute('data-easter-egg-initialized')) {
        return;
      }
      
      console.log('Adding click handler to:', heading.textContent.trim());
      heading.setAttribute('data-easter-egg-initialized', 'true');
      
      heading.addEventListener('click', function(event) {
        console.log('Heading clicked:', this.textContent.trim());
        
        // Toggle the easter-egg-activated class for CSS animations
        this.classList.add('easter-egg-activated');
        console.log('Class added:', this.classList.contains('easter-egg-activated'));
        
        // Try to play sound
try {
const audio = new Audio('https://cdn.shopify.com/s/files/1/0695/4303/5045/files/bark.mp3?v=1743306348');
  audio.play().then(() => {
    console.log('Audio played');
  }).catch(e => {
    console.log('Audio play failed:', e);
  });
} catch(e) {
  console.log('Audio error:', e);
}

        
        // Remove the class after 2 seconds
        setTimeout(() => {
          this.classList.remove('easter-egg-activated');
        }, 2000);
        
        // Prevent event bubbling
        event.preventDefault();
        event.stopPropagation();
      });
    });
  }
  
  function setupMutationObserver() {
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.addedNodes && mutation.addedNodes.length > 0) {
          for (let i = 0; i < mutation.addedNodes.length; i++) {
            const node = mutation.addedNodes[i];
            if (node.nodeType === 1) { // Element node
              // Check if the node or any of its children match our selectors
              const newHeadings = node.querySelectorAll('.section-template--18619066646693__rich_text_3EQ4Y8-padding h1, .section-template--18619066646693__rich_text_3EQ4Y8-padding .h1, .section-template--18619066646693__rich_text_3EQ4Y8-padding h2.h1');
              
              if (newHeadings.length > 0) {
                console.log('Found headings via MutationObserver:', newHeadings.length);
                attachClickHandlers(newHeadings);
                observer.disconnect(); // Stop observing once we've found what we need
                return;
              }
              
              // Also check if the node itself matches
              if (node.matches && node.matches('.section-template--18619066646693__rich_text_3EQ4Y8-padding h1, .section-template--18619066646693__rich_text_3EQ4Y8-padding .h1, .section-template--18619066646693__rich_text_3EQ4Y8-padding h2.h1')) {
                console.log('Found heading node via MutationObserver');
                attachClickHandlers([node]);
                observer.disconnect(); // Stop observing once we've found what we need
                return;
              }
            }
          }
        }
      });
    });
    
    // Start observing the document body
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }
}